import React from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/used-players-list/actions';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/game-types/single-game';

class FilterComponent extends BaseFilterComponent {
    onChange(value) {
        this.props.dispatch(Action.set('FilterSingleGame', value));
        this.props.dispatch(Action.do('filterByPlayersType', value));
    }

    render() {
        const tabs = this.prepareTabs();
        return <div className="tabs-chk-holder">{tabs}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
        filters: state.usedPlayers.filters,
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
